module.exports = __webpack_public_path__ + "static/media/num.ebe0de22.svg";